import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function AboutSection() {
  return <section id="about" className="py-20 bg-white" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-19">
          <AnimatedSection data-id="element-20">
            <div className="relative mb-12 lg:mb-0" data-id="element-21">
              <div className="aspect-w-3 aspect-h-2 rounded-2xl overflow-hidden shadow-2xl" data-id="element-22">
                <img src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Experiential event production with dynamic lighting" className="w-full h-full object-center object-cover" data-id="element-23" />
              </div>
              <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-indigo-50 rounded-2xl -z-10" data-id="element-24"></div>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.2} data-id="element-25">
            <div data-id="element-26">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6" data-id="element-27">
                Why Agencies Choose Turnout
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-28">
                Events are one of the highest-converting go-to-market motions an
                agency can offer. But for a lean software or marketing team,
                building a full events practice means hiring planners,
                coordinators, and producers you cannot justify. So most agencies
                leave the opportunity on the table.
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-29">
                Turnout is the events team behind your agency. We handle event
                identity, guest outreach, venue management, host prep, and
                co-hosting on the day. Your team stays small. Your event
                practice runs like a full-service shop. And events become a new
                revenue line you can sell tomorrow.
              </p>
              <div className="grid grid-cols-2 gap-6 text-center" data-id="element-30">
                <AnimatedSection delay={0.4} data-id="element-31">
                  <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-32">
                    <p className="text-4xl font-bold text-indigo-600 mb-1" data-id="element-33">
                      50+
                    </p>
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-34">
                      Agencies
                    </p>
                  </div>
                </AnimatedSection>
                <AnimatedSection delay={0.5} data-id="element-35">
                  <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-36">
                    <p className="text-4xl font-bold text-indigo-600 mb-1" data-id="element-37">
                      1k+
                    </p>
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-38">
                      Events Powered
                    </p>
                  </div>
                </AnimatedSection>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>;
}